
document.addEventListener('click', (e) => {

    const sortBtn = e.target.closest('.sort-by-wrapper');
  
    if (sortBtn) {
      e.stopPropagation();
  
      const wrapper = sortBtn.closest('.custom-sort-container');
      const sortList = wrapper.querySelector('.sort-by-list');
  
      document.querySelectorAll('.sort-by-list').forEach(list => {
        if (list !== sortList) {
          list.classList.remove('show');
        }
      });
  
      sortList.classList.toggle('show');
      return;
    }
  
    const sortItem = e.target.closest('.sort-by-list li');
  
    if (sortItem) {
  
      const wrapper = sortItem.closest('.custom-sort-container');
      const sortList = wrapper.querySelector('.sort-by-list');
      const selectValue = wrapper.querySelector('.select-value');
  
      const value = sortItem.dataset.sortValue;
      const label = sortItem.textContent.trim();
  
      selectValue.textContent = label;
  
      sortList.querySelectorAll('li').forEach(li => {
        li.classList.remove('is-active');
      });
  
      sortItem.classList.add('is-active');
      sortList.classList.remove('show');
  
      const FacetSortDrawerForm = document.getElementById('FacetSortDrawerForm') || document.getElementById('FacetFiltersForm');
      const desktopSort = document.getElementById('SortBy');
      // const mobileSort = document.getElementById('SortBy-mobile');
  
      if (desktopSort) {
        desktopSort.value = value;
        desktopSort.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }
  
      if(FacetSortDrawerForm){
          FacetSortDrawerForm.dispatchEvent(
              new Event('input', { bubbles: true })
          );
      }
  
      // if (mobileSort) {
      //   mobileSort.value = value;
      //   mobileSort.dispatchEvent(
      //     new Event('change', { bubbles: true })
      //   );
      // }
  
      return;
    }
  
    document.querySelectorAll('.sort-by-list').forEach(list => {
      list.classList.remove('show');
    });
  
  
    
  });
  
  
  Fancybox.bind('[data-fancybox]', {});
  
  // window.initCartDrawerRecommendedSwiper = function () {
  //     document.querySelectorAll('.cart-recommand-product-mySwiper').forEach(function (el) {
  //         const section = el.closest('.cart-recommand__sec');
  //         if (!section) return;
  
  //         const prevButton = section.querySelector('.prev-btn');
  //         const nextButton = section.querySelector('.next-btn');
  //         const progressBar = section.querySelector('.cart-recommand-progress');
  
  //         if (el.swiper) {
  //             el.swiper.destroy(true, true);
  //         }
  
  //         new Swiper(el, {
  //             loop: false,
  //             slidesPerView: 1.3,
  //             spaceBetween: 10,
  //             navigation: {
  //                 prevEl: prevButton,
  //                 nextEl: nextButton,
  //             },
  //             pagination: {
  //                 el: progressBar,
  //                 type: 'progressbar',
  //             },
  //             breakpoints: {
  //                 750: {
  //                     slidesPerView: 1.5,
  //                     spaceBetween: 14,
  //                 },
  //                 990: {
  //                     slidesPerView: 1.73,
  //                     spaceBetween: 20,
  //                 },
  //             },
  //         });
  //     });
  // };
  
  window.initComplementarySwiper = function () {
      document.querySelectorAll('.mySwiper-complementary').forEach(function (el) {
          const container = el.closest('.complementary-products__container') || el.parentElement;
          const prevButton = container.querySelector('.slider-button--prev');
          const nextButton = container.querySelector('.slider-button--next');
          const pagination = el.querySelector('.complementary-swiper-pagination');
  
          if (el.swiper) {
              el.swiper.destroy(true, true);
          }
  
          const slideCount = el.querySelectorAll('.swiper-slide').length;
          if (slideCount <= 1) return;
  
          new Swiper(el, {
              slidesPerView: 1.4,
              slidesPerGroup: 1,
              spaceBetween: 16,
              watchOverflow: true,
  
              navigation: {
                  prevEl: prevButton,
                  nextEl: nextButton,
              },
  
              pagination: pagination
                  ? {
                        el: pagination,
                        type: 'progressbar',
                    }
                  : false,
  
              breakpoints: {
                  320: {
                      slidesPerView: 1.3,
                      spaceBetween: 10,
                  },
                  767: {
                      slidesPerView: 1.1,
                      spaceBetween: 10,
                  },
                   1024: {
                      slidesPerView: 1.4,
                      spaceBetween: 16,
                  },
              }
          });
      });
  };
  
  initCartDrawerRecommendedSwiper();
  initComplementarySwiper(); 
  